import { BaseScene } from '@scarybeasties/phaser-framework-core/scenes';
import { SceneId } from './app-routing';

import Boot from './scenes/Boot';
import PreloadGeneric from './scenes/PreloadGeneric';
import Title from './scenes/Title';
import LevelSelect from './scenes/LevelSelect';
import Game from './scenes/Game';
import GameUI from './scenes/GameUI';
import DebugUI from './scenes/DebugUI';
import TransitionSceneToScene from './scenes/TransitionSceneToScene';
import TransitionLoadScene from './scenes/TransitionLoadScene';
import CharacterSelect from "./scenes/CharacterSelect";

export const sceneIdToSceneMap: Map<string, typeof BaseScene> = new Map([
  [SceneId.Boot, Boot],
  [SceneId.PreloadGeneric, PreloadGeneric],
  [SceneId.Title, Title],
  [SceneId.LevelSelect, LevelSelect],
  [SceneId.CharacterSelect, CharacterSelect],
  [SceneId.Game, Game],
  [SceneId.GameUI, GameUI],
  [SceneId.TransitionSceneToScene, TransitionSceneToScene],
  [SceneId.TransitionLoadScene, TransitionLoadScene],
  [SceneId.DebugUI, DebugUI]
]);
